import request from '@/utils/request'

// 进程列表
export function processList(data) {
  return request({
    url: 'bussiness/postprocess/list',
    method: 'get',
    params:data
  })
};

//准考证信息
export function printMessage(data) {

  return request({
    url: 'system/ticket/print',
    method: 'post',
    data
  })
};
//成绩查询
export function selectScore(data) {

  return request({
    url: 'bussiness/postprocess/selectScore',
    method: 'put',
    data
  })
};
//消息接口
export function printMessageDetail(data) {

  return request({
    url: 'bussiness/postprocess/getInfo',
    method: 'get',
    params:data
  })
}
//咨询
export function postprocessAdd(data) {

  return request({
    url: 'bussiness/postprocess/add',
    method: 'post',
    data
  })
}

export function changeStatusAndSendMsg(data){
  return request({
    url: 'bussiness/talent/changeStatusAndSendMsg',
    method: 'post',
    data
  })

}
//根据orgCode获取配置信息
export function getSettingByOrgCode(orgCode){
  return request({
    url:'/bussiness/config/getSettingByOrgCode?orgCode='+orgCode,
    method:'get',
  })
}




// WEBPACK FOOTER //
// ./src/api/process.js